import { graphql, useStaticQuery } from 'gatsby';

const FORCE_RELOAD_KEY = 'fr'

export const useCommonQuery = () => {
  try {
    const result = useCommonQueryData();
    return result;
  } catch (ex) {
    if (!window) {
      throw ex;
    }

    const url = new URL(window.location.href)

    if (!url.searchParams.has(FORCE_RELOAD_KEY) && !process.env.GATSBY_DEV) {
      url.searchParams.set(FORCE_RELOAD_KEY, `1`);
      window.location.href = url.href;
    }

    throw ex;
  }
};

const useCommonQueryData = () => {
  const data = useStaticQuery(graphql`fragment navFragment on NavSegment {
    id
    title
    relativeUrl
    hideChildren
    hidden
    tag
    tier
    subRoot
    indexable
    indexPage
  }
  
  query CommonQuery{
    site {
      siteMetadata {
        pathPrefix
        template
        productId
        productName
        productUrl
        productTrialUrl
        freemiumUrl
        rootUrl
        searchProvider
        searchEngineId
        googleApiKey
        defaultTitlePrefix
        googleSearchApiBaseUrl
        ctaOverviewMessage
        ctaIntroMessage
        ctaSmallMessage
        ctaFreeTierTitle
        ctaFreeTierMessage
        ctaPremiumTierMessage
        ctaMixedTierTitle
        ctaMixedTierMessage
        ctaFreemiumLinkText
        ctaFreemiumShortLinkText
        tagManagerContainerId
        testTagManagerContainerId
        oneTrustScriptTemplate
        feedbackFormCss
        feedbackFormScript
        productCode
        contributeUrl
        ctaInsertAutomatically
        generativeAnswerEnabled,
        generativeAnswerSearchConfiguration,
        paragServiceUrl,
        paragServiceTestUrl,
        dojoScripts {
          kendoCdnVersion
          themesCdnVersion
          pdfJsVersion
          jQueryVersion 
          dojoLocalJsPath
          dojoLocalCssPath
        },
        sitefinityFooter
        imageClick
        aiChatPromptSuggestions {
          text
        }
        sitefinityCtaLinks {
          text
          url
        }
        versionsRoot
        currentVersion
        sitefinityLearnMoreResources
      }
    }
    avatarIcon: file(sourceInstanceName: {eq: "asset-avatar-icon"}) {
      publicURL
    }
    noResultsIcon: file(sourceInstanceName: {eq: "asset-no-results-icon"}) {
      publicURL
    }
    telerikNavigation {
      footerMarkup
      headerMarkup
    }
    demoConfiguration {
      metaFileName
      defaultTheme
      actions
      themes
      uris
    }
    navSegment(parentSegment: {id: {eq: null}}) {
      ...navFragment
      childrenSegments {
        ...navFragment
        childrenSegments {
          ...navFragment
          childrenSegments {
            ...navFragment
            childrenSegments {
              ...navFragment
              childrenSegments {
                ...navFragment
                childrenSegments {
                  ...navFragment
                  childrenSegments {
                    ...navFragment
                    childrenSegments {
                      ...navFragment
                      childrenSegments {
                        ...navFragment
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`);

  return data;
}
